<template>
  <div
    class="block-transition"
    ref="refRoot"
    :class="{ animateIn, color }"
  >
    <!-- :style="{ '--color': color }" -->
    <div
      v-for="(row, rowIdx) in numRows"
      class="row"
      :key="`block-row-${row}`"
    >
      <div
        v-for="(col, colIdx) in numCols"
        class="col"
        :key="`block-col-${row}-${col}`"
      >
        <div
          class="block"
          :row="row"
          :col="col"
        >
          <!-- <div class="color" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SITE_IN_DURATION } from "@/config"
import { PageState } from "@/providers/page/pageState"
import { useAppStore } from "@/stores/app"

const props = defineProps({
  // progress: {
  //   type: Number,
  // },
  color: {
    default: "white",
  },
  trigger: {},
  animateIn: {
    default: false,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const env = useEnv()
const numRows = computed(() => 6)
const numCols = computed(() => (env.isMobile ? 3 : 6))

// const onEnter = function (el, done) {
//   const tl = $gsap.timeline({ onComplete: done })

//   const q = $gsap.utils.selector(refRoot.value)

//   let rows = q(".row")
//   rows = [...rows].reverse()

//   tl.add("in")
//   for (let idx = 0; idx < rows.length; idx++) {
//     // console.log(idx, block)
//     const row = rows[idx]
//     const block = row.querySelectorAll(".block")

//     tl.fromTo(
//       block,
//       { x: "-101%" },
//       {
//         x: 0,
//         duration: 0.5,
//         stagger: 0.1,
//       },
//       `in+=${idx * 0.15}`
//     )
//   }

//   tl.fromTo(q(".icon"), { opacity: 0 }, { opacity: 1, duration: 0.5 }, "-=0.5")

//   let targetDuration = SITE_IN_DURATION * 0.8
//   tl.timeScale(tl.duration() / targetDuration)

//   return tl.then()
// }

const { init: initST } = useScrollTrigger(() => {
  if (!props.animateIn) return

  // console.log("BlockTransition", props.trigger)

  let tl = $gsap.timeline({
    scrollTrigger: {
      trigger: props.trigger,
      start: () => `top bottom+=${browser.lvh * 0.25}`,
      end: "top top",
      scrub: true,
      // markers: true,
    },
  })

  const q = $gsap.utils.selector(refRoot.value)

  let rows = q(".row")

  tl.add("start")

  for (let idx = 0; idx < rows.length; idx++) {
    const rowLabel = `row${idx}`
    tl.add(rowLabel, `start+=${1 / numRows.value}`)
    const row = rows[idx]

    let cols = row.querySelectorAll(".col")
    cols = [...cols].reverse()

    for (let colIdx = 0; colIdx < numCols.value; colIdx++) {
      const colLabel = `${rowLabel}-col${colIdx}`
      let col = cols[colIdx]

      let block = col.querySelector(".block")

      tl.set(col, { y: `${100 + colIdx * 50}%` }, "start")
      tl.set(block, { scaleY: 0 }, "start")

      tl.add(colLabel, `rowLabel+=${1 / numCols.value}`)
      tl.fromTo(
        col,
        { y: `${100 + colIdx * 50}%` },
        {
          y: 0,
          duration: 1,
          ease: "power1.in",
          immediateRender: true,
        },
        `${colLabel}+=${(rows.length - idx) * 0.1}`
      )

      tl.fromTo(
        block,
        { scaleY: 0 },
        {
          scaleY: 1,
          duration: 1,
          ease: "power1.in",
          immediateRender: true,
        },
        `${colLabel}+=${(rows.length - idx) * 0.1}`
      )
    }
  }
}, false)

watch(() => [props.animateIn, props.trigger], initST)
onMounted(async () => {
  await nextTick()
  initST()
})
// useResize(initST)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.block-transition {
  @include fill();
  @include flex(column, center, stretch);
  --color: #{$cl-light};

  &.black {
    --color: #{$cl-black};
  }

  .row {
    flex: 1;
    @include flex(row, stretch, stretch);
  }
  .col {
    position: relative;
    flex: 1;
    // overflow: hidden;
    margin: -1px;
  }
  .block {
    @include fill;
    // overflow: hidden;
    background: var(--color);

    transform-origin: top;

    // .color {
    //   @include fill;
    // }
  }

  &.animateIn {
    .block {
      transform: scaleY(0);
    }
  }
}
</style>
